import * as React from 'react';
import { __ } from 'react-i18n';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexRowCenterVertical } from '../../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../../Defaults/Text';
import { CartInfoPopup } from './CartInfoPopup';

interface Props {
  title: string;
  value: string;
  borderBottom?: boolean;
  showInfo: number;
  order?: number;
}

function FinalValue({ title, value, borderBottom, showInfo, order }: Props) {
  return (
    <FinalPriceWrapper order={order} borderBottom={borderBottom}>
      {showInfo > 0 && (
        <CartInfoPopup
          message={__(
            'Cena produktov, ktoré nie sú skladom, nie je započítaná do hodnoty objednávky a ceny dopravy.',
          )}
          isAvailable={true}
          isRed={showInfo === 2}
        />
      )}
      <FinalPriceText hasMarginLeft={showInfo > 0}>{title}</FinalPriceText>
      <FinalPrice>{value}</FinalPrice>
    </FinalPriceWrapper>
  );
}
const FinalPriceWrapper = styled(FlexRowCenterVertical)<{ order?: number }>`
  justify-content: space-between;
  width: 100%;
  margin-top: ${rem(16)};
  margin-bottom: ${rem(32)};
  order: ${({ order }) => (order ? order : 'unset')};
`;

const FinalPriceText = styled(TextP)<{ hasMarginLeft: boolean }>`
  font-family: ${({ theme }) => theme.font.secondaryLight};
  font-weight: 400;
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  margin-right: ${rem(32)};
  margin-left: ${({ hasMarginLeft }) => (hasMarginLeft ? rem(8) : 0)};
`;

const FinalPrice = styled(TextP)`
  font-size: ${rem(20)};
  line-height: ${rem(28)};
  white-space: nowrap;
`;

export { FinalValue };
